@if (!href) {
  <button [type]="type" class="icon-button" [class.border]="border" matButton="filled" [disabled]="disabled" [tabIndex]="tabIndex">
    <mat-icon [svgIcon]="icon" [class.small]="smallIcon"></mat-icon>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}
@if (href) {
  <a class="icon-button" [class.border]="border" matButton="filled" [attr.disabled]="disabled" [href]="href" [tabIndex]="tabIndex">
    <mat-icon [svgIcon]="icon" [class.small]="smallIcon"></mat-icon>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}
<ng-template #content>
  <span class="screen-reader-only"><ng-content></ng-content></span>
</ng-template>
